module.exports = __webpack_public_path__ + "static/media/oret-studio-5.ad31bed7.jpg";